import MyAccountButton from './MyAccountButton'

export default MyAccountButton
